import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  geography: {
  type: 'Point';
  crs?: {
    type: 'name';
    properties: {
      name: 'urn:ogc:def:crs:EPSG::4326';
    };
  };
  coordinates: [number, number];
};
  geometry: any;
  jsonb: | { is_unlocked: boolean } | { is_open: boolean } | { is_backup_battery: boolean } | { is_unlocked: boolean; is_open: boolean; is_backup_battery: boolean } | { type: Unlock_Request_Type_Enum };
  timestamptz: string;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type Coords = {
  __typename?: 'Coords';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type OpenBoxOutput = {
  __typename?: 'OpenBoxOutput';
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "battery_status_message" */
export type Battery_Status_Message = {
  __typename?: 'battery_status_message';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_backup_battery: Scalars['Boolean'];
};

/** aggregated selection of "battery_status_message" */
export type Battery_Status_Message_Aggregate = {
  __typename?: 'battery_status_message_aggregate';
  aggregate?: Maybe<Battery_Status_Message_Aggregate_Fields>;
  nodes: Array<Battery_Status_Message>;
};

/** aggregate fields of "battery_status_message" */
export type Battery_Status_Message_Aggregate_Fields = {
  __typename?: 'battery_status_message_aggregate_fields';
  avg?: Maybe<Battery_Status_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Battery_Status_Message_Max_Fields>;
  min?: Maybe<Battery_Status_Message_Min_Fields>;
  stddev?: Maybe<Battery_Status_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Battery_Status_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Battery_Status_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Battery_Status_Message_Sum_Fields>;
  var_pop?: Maybe<Battery_Status_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Battery_Status_Message_Var_Samp_Fields>;
  variance?: Maybe<Battery_Status_Message_Variance_Fields>;
};


/** aggregate fields of "battery_status_message" */
export type Battery_Status_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "battery_status_message" */
export type Battery_Status_Message_Aggregate_Order_By = {
  avg?: Maybe<Battery_Status_Message_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Battery_Status_Message_Max_Order_By>;
  min?: Maybe<Battery_Status_Message_Min_Order_By>;
  stddev?: Maybe<Battery_Status_Message_Stddev_Order_By>;
  stddev_pop?: Maybe<Battery_Status_Message_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Battery_Status_Message_Stddev_Samp_Order_By>;
  sum?: Maybe<Battery_Status_Message_Sum_Order_By>;
  var_pop?: Maybe<Battery_Status_Message_Var_Pop_Order_By>;
  var_samp?: Maybe<Battery_Status_Message_Var_Samp_Order_By>;
  variance?: Maybe<Battery_Status_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "battery_status_message" */
export type Battery_Status_Message_Arr_Rel_Insert_Input = {
  data: Array<Battery_Status_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Battery_Status_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Battery_Status_Message_Avg_Fields = {
  __typename?: 'battery_status_message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "battery_status_message" */
export type Battery_Status_Message_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "battery_status_message". All fields are combined with a logical 'AND'. */
export type Battery_Status_Message_Bool_Exp = {
  _and?: Maybe<Array<Battery_Status_Message_Bool_Exp>>;
  _not?: Maybe<Battery_Status_Message_Bool_Exp>;
  _or?: Maybe<Array<Battery_Status_Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_backup_battery?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "battery_status_message" */
export enum Battery_Status_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  BatteryStatusMessagePkey = 'battery_status_message_pkey'
}

/** input type for incrementing numeric columns in table "battery_status_message" */
export type Battery_Status_Message_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "battery_status_message" */
export type Battery_Status_Message_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Battery_Status_Message_Max_Fields = {
  __typename?: 'battery_status_message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "battery_status_message" */
export type Battery_Status_Message_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Battery_Status_Message_Min_Fields = {
  __typename?: 'battery_status_message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "battery_status_message" */
export type Battery_Status_Message_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "battery_status_message" */
export type Battery_Status_Message_Mutation_Response = {
  __typename?: 'battery_status_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Battery_Status_Message>;
};

/** on_conflict condition type for table "battery_status_message" */
export type Battery_Status_Message_On_Conflict = {
  constraint: Battery_Status_Message_Constraint;
  update_columns?: Array<Battery_Status_Message_Update_Column>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "battery_status_message". */
export type Battery_Status_Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_backup_battery?: Maybe<Order_By>;
};

/** primary key columns input for table: battery_status_message */
export type Battery_Status_Message_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "battery_status_message" */
export enum Battery_Status_Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBackupBattery = 'is_backup_battery'
}

/** input type for updating data in table "battery_status_message" */
export type Battery_Status_Message_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Battery_Status_Message_Stddev_Fields = {
  __typename?: 'battery_status_message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "battery_status_message" */
export type Battery_Status_Message_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Battery_Status_Message_Stddev_Pop_Fields = {
  __typename?: 'battery_status_message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "battery_status_message" */
export type Battery_Status_Message_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Battery_Status_Message_Stddev_Samp_Fields = {
  __typename?: 'battery_status_message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "battery_status_message" */
export type Battery_Status_Message_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Battery_Status_Message_Sum_Fields = {
  __typename?: 'battery_status_message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "battery_status_message" */
export type Battery_Status_Message_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "battery_status_message" */
export enum Battery_Status_Message_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBackupBattery = 'is_backup_battery'
}

/** aggregate var_pop on columns */
export type Battery_Status_Message_Var_Pop_Fields = {
  __typename?: 'battery_status_message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "battery_status_message" */
export type Battery_Status_Message_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Battery_Status_Message_Var_Samp_Fields = {
  __typename?: 'battery_status_message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "battery_status_message" */
export type Battery_Status_Message_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Battery_Status_Message_Variance_Fields = {
  __typename?: 'battery_status_message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "battery_status_message" */
export type Battery_Status_Message_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "boot_regular_message" */
export type Boot_Regular_Message = {
  __typename?: 'boot_regular_message';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_backup_battery: Scalars['Boolean'];
  is_open: Scalars['Boolean'];
  is_unlocked: Scalars['Boolean'];
};

/** aggregated selection of "boot_regular_message" */
export type Boot_Regular_Message_Aggregate = {
  __typename?: 'boot_regular_message_aggregate';
  aggregate?: Maybe<Boot_Regular_Message_Aggregate_Fields>;
  nodes: Array<Boot_Regular_Message>;
};

/** aggregate fields of "boot_regular_message" */
export type Boot_Regular_Message_Aggregate_Fields = {
  __typename?: 'boot_regular_message_aggregate_fields';
  avg?: Maybe<Boot_Regular_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Boot_Regular_Message_Max_Fields>;
  min?: Maybe<Boot_Regular_Message_Min_Fields>;
  stddev?: Maybe<Boot_Regular_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Boot_Regular_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Boot_Regular_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Boot_Regular_Message_Sum_Fields>;
  var_pop?: Maybe<Boot_Regular_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Boot_Regular_Message_Var_Samp_Fields>;
  variance?: Maybe<Boot_Regular_Message_Variance_Fields>;
};


/** aggregate fields of "boot_regular_message" */
export type Boot_Regular_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "boot_regular_message" */
export type Boot_Regular_Message_Aggregate_Order_By = {
  avg?: Maybe<Boot_Regular_Message_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Boot_Regular_Message_Max_Order_By>;
  min?: Maybe<Boot_Regular_Message_Min_Order_By>;
  stddev?: Maybe<Boot_Regular_Message_Stddev_Order_By>;
  stddev_pop?: Maybe<Boot_Regular_Message_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Boot_Regular_Message_Stddev_Samp_Order_By>;
  sum?: Maybe<Boot_Regular_Message_Sum_Order_By>;
  var_pop?: Maybe<Boot_Regular_Message_Var_Pop_Order_By>;
  var_samp?: Maybe<Boot_Regular_Message_Var_Samp_Order_By>;
  variance?: Maybe<Boot_Regular_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "boot_regular_message" */
export type Boot_Regular_Message_Arr_Rel_Insert_Input = {
  data: Array<Boot_Regular_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Boot_Regular_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Boot_Regular_Message_Avg_Fields = {
  __typename?: 'boot_regular_message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "boot_regular_message". All fields are combined with a logical 'AND'. */
export type Boot_Regular_Message_Bool_Exp = {
  _and?: Maybe<Array<Boot_Regular_Message_Bool_Exp>>;
  _not?: Maybe<Boot_Regular_Message_Bool_Exp>;
  _or?: Maybe<Array<Boot_Regular_Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_backup_battery?: Maybe<Boolean_Comparison_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  is_unlocked?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "boot_regular_message" */
export enum Boot_Regular_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  BootRegularMessagePkey = 'boot_regular_message_pkey'
}

/** input type for incrementing numeric columns in table "boot_regular_message" */
export type Boot_Regular_Message_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "boot_regular_message" */
export type Boot_Regular_Message_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Boot_Regular_Message_Max_Fields = {
  __typename?: 'boot_regular_message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Boot_Regular_Message_Min_Fields = {
  __typename?: 'boot_regular_message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "boot_regular_message" */
export type Boot_Regular_Message_Mutation_Response = {
  __typename?: 'boot_regular_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Boot_Regular_Message>;
};

/** on_conflict condition type for table "boot_regular_message" */
export type Boot_Regular_Message_On_Conflict = {
  constraint: Boot_Regular_Message_Constraint;
  update_columns?: Array<Boot_Regular_Message_Update_Column>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "boot_regular_message". */
export type Boot_Regular_Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_backup_battery?: Maybe<Order_By>;
  is_open?: Maybe<Order_By>;
  is_unlocked?: Maybe<Order_By>;
};

/** primary key columns input for table: boot_regular_message */
export type Boot_Regular_Message_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "boot_regular_message" */
export enum Boot_Regular_Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBackupBattery = 'is_backup_battery',
  /** column name */
  IsOpen = 'is_open',
  /** column name */
  IsUnlocked = 'is_unlocked'
}

/** input type for updating data in table "boot_regular_message" */
export type Boot_Regular_Message_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Boot_Regular_Message_Stddev_Fields = {
  __typename?: 'boot_regular_message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Boot_Regular_Message_Stddev_Pop_Fields = {
  __typename?: 'boot_regular_message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Boot_Regular_Message_Stddev_Samp_Fields = {
  __typename?: 'boot_regular_message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Boot_Regular_Message_Sum_Fields = {
  __typename?: 'boot_regular_message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "boot_regular_message" */
export enum Boot_Regular_Message_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBackupBattery = 'is_backup_battery',
  /** column name */
  IsOpen = 'is_open',
  /** column name */
  IsUnlocked = 'is_unlocked'
}

/** aggregate var_pop on columns */
export type Boot_Regular_Message_Var_Pop_Fields = {
  __typename?: 'boot_regular_message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Boot_Regular_Message_Var_Samp_Fields = {
  __typename?: 'boot_regular_message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Boot_Regular_Message_Variance_Fields = {
  __typename?: 'boot_regular_message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "boot_regular_message" */
export type Boot_Regular_Message_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "box" */
export type Box = {
  __typename?: 'box';
  address?: Maybe<Scalars['String']>;
  /** An array relationship */
  battery_status_messages: Array<Battery_Status_Message>;
  /** An aggregate relationship */
  battery_status_messages_aggregate: Battery_Status_Message_Aggregate;
  /** An array relationship */
  boot_regular_messages: Array<Boot_Regular_Message>;
  /** An aggregate relationship */
  boot_regular_messages_aggregate: Boot_Regular_Message_Aggregate;
  /** An array relationship */
  box_statuses: Array<Box_Status>;
  /** An aggregate relationship */
  box_statuses_aggregate: Box_Status_Aggregate;
  coords: Scalars['geography'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  door_status_messages: Array<Door_Status_Message>;
  /** An aggregate relationship */
  door_status_messages_aggregate: Door_Status_Message_Aggregate;
  /** An object relationship */
  employee?: Maybe<Employee>;
  id: Scalars['Int'];
  imei: Scalars['String'];
  /** An array relationship */
  key_status_messages: Array<Key_Status_Message>;
  /** An aggregate relationship */
  key_status_messages_aggregate: Key_Status_Message_Aggregate;
  name: Scalars['String'];
  plate_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Prefecture_Enum>;
  /** An object relationship */
  prefectureByPrefecture?: Maybe<Prefecture>;
  /** An array relationship */
  unlock_request_messages: Array<Unlock_Request_Message>;
  /** An aggregate relationship */
  unlock_request_messages_aggregate: Unlock_Request_Message_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};


/** columns and relationships of "box" */
export type BoxBattery_Status_MessagesArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxBattery_Status_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxBoot_Regular_MessagesArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxBoot_Regular_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxBox_StatusesArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxBox_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxDoor_Status_MessagesArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxDoor_Status_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxKey_Status_MessagesArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxKey_Status_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxUnlock_Request_MessagesArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


/** columns and relationships of "box" */
export type BoxUnlock_Request_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};

/** aggregated selection of "box" */
export type Box_Aggregate = {
  __typename?: 'box_aggregate';
  aggregate?: Maybe<Box_Aggregate_Fields>;
  nodes: Array<Box>;
};

/** aggregate fields of "box" */
export type Box_Aggregate_Fields = {
  __typename?: 'box_aggregate_fields';
  avg?: Maybe<Box_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Box_Max_Fields>;
  min?: Maybe<Box_Min_Fields>;
  stddev?: Maybe<Box_Stddev_Fields>;
  stddev_pop?: Maybe<Box_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Box_Stddev_Samp_Fields>;
  sum?: Maybe<Box_Sum_Fields>;
  var_pop?: Maybe<Box_Var_Pop_Fields>;
  var_samp?: Maybe<Box_Var_Samp_Fields>;
  variance?: Maybe<Box_Variance_Fields>;
};


/** aggregate fields of "box" */
export type Box_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Box_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "box" */
export type Box_Aggregate_Order_By = {
  avg?: Maybe<Box_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Box_Max_Order_By>;
  min?: Maybe<Box_Min_Order_By>;
  stddev?: Maybe<Box_Stddev_Order_By>;
  stddev_pop?: Maybe<Box_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Box_Stddev_Samp_Order_By>;
  sum?: Maybe<Box_Sum_Order_By>;
  var_pop?: Maybe<Box_Var_Pop_Order_By>;
  var_samp?: Maybe<Box_Var_Samp_Order_By>;
  variance?: Maybe<Box_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "box" */
export type Box_Arr_Rel_Insert_Input = {
  data: Array<Box_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Box_On_Conflict>;
};

/** aggregate avg on columns */
export type Box_Avg_Fields = {
  __typename?: 'box_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "box" */
export type Box_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "box". All fields are combined with a logical 'AND'. */
export type Box_Bool_Exp = {
  _and?: Maybe<Array<Box_Bool_Exp>>;
  _not?: Maybe<Box_Bool_Exp>;
  _or?: Maybe<Array<Box_Bool_Exp>>;
  address?: Maybe<String_Comparison_Exp>;
  battery_status_messages?: Maybe<Battery_Status_Message_Bool_Exp>;
  boot_regular_messages?: Maybe<Boot_Regular_Message_Bool_Exp>;
  box_statuses?: Maybe<Box_Status_Bool_Exp>;
  coords?: Maybe<Geography_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  door_status_messages?: Maybe<Door_Status_Message_Bool_Exp>;
  employee?: Maybe<Employee_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  imei?: Maybe<String_Comparison_Exp>;
  key_status_messages?: Maybe<Key_Status_Message_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  plate_number?: Maybe<String_Comparison_Exp>;
  postcode?: Maybe<String_Comparison_Exp>;
  prefecture?: Maybe<Prefecture_Enum_Comparison_Exp>;
  prefectureByPrefecture?: Maybe<Prefecture_Bool_Exp>;
  unlock_request_messages?: Maybe<Unlock_Request_Message_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "box" */
export enum Box_Constraint {
  /** unique or primary key constraint on columns "imei" */
  BoxImeiKey = 'box_imei_key',
  /** unique or primary key constraint on columns "id" */
  BoxPkey = 'box_pkey'
}

/** input type for incrementing numeric columns in table "box" */
export type Box_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "box" */
export type Box_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  battery_status_messages?: Maybe<Battery_Status_Message_Arr_Rel_Insert_Input>;
  boot_regular_messages?: Maybe<Boot_Regular_Message_Arr_Rel_Insert_Input>;
  box_statuses?: Maybe<Box_Status_Arr_Rel_Insert_Input>;
  coords?: Maybe<Scalars['geography']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  door_status_messages?: Maybe<Door_Status_Message_Arr_Rel_Insert_Input>;
  employee?: Maybe<Employee_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  imei?: Maybe<Scalars['String']>;
  key_status_messages?: Maybe<Key_Status_Message_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  plate_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Prefecture_Enum>;
  prefectureByPrefecture?: Maybe<Prefecture_Obj_Rel_Insert_Input>;
  unlock_request_messages?: Maybe<Unlock_Request_Message_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Box_Max_Fields = {
  __typename?: 'box_max_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  imei?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "box" */
export type Box_Max_Order_By = {
  address?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  imei?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  plate_number?: Maybe<Order_By>;
  postcode?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Box_Min_Fields = {
  __typename?: 'box_min_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  imei?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "box" */
export type Box_Min_Order_By = {
  address?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  imei?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  plate_number?: Maybe<Order_By>;
  postcode?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "box" */
export type Box_Mutation_Response = {
  __typename?: 'box_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Box>;
};

/** input type for inserting object relation for remote table "box" */
export type Box_Obj_Rel_Insert_Input = {
  data: Box_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Box_On_Conflict>;
};

/** on_conflict condition type for table "box" */
export type Box_On_Conflict = {
  constraint: Box_Constraint;
  update_columns?: Array<Box_Update_Column>;
  where?: Maybe<Box_Bool_Exp>;
};

/** Ordering options when selecting data from "box". */
export type Box_Order_By = {
  address?: Maybe<Order_By>;
  battery_status_messages_aggregate?: Maybe<Battery_Status_Message_Aggregate_Order_By>;
  boot_regular_messages_aggregate?: Maybe<Boot_Regular_Message_Aggregate_Order_By>;
  box_statuses_aggregate?: Maybe<Box_Status_Aggregate_Order_By>;
  coords?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  door_status_messages_aggregate?: Maybe<Door_Status_Message_Aggregate_Order_By>;
  employee?: Maybe<Employee_Order_By>;
  id?: Maybe<Order_By>;
  imei?: Maybe<Order_By>;
  key_status_messages_aggregate?: Maybe<Key_Status_Message_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  plate_number?: Maybe<Order_By>;
  postcode?: Maybe<Order_By>;
  prefecture?: Maybe<Order_By>;
  prefectureByPrefecture?: Maybe<Prefecture_Order_By>;
  unlock_request_messages_aggregate?: Maybe<Unlock_Request_Message_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: box */
export type Box_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "box" */
export enum Box_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Coords = 'coords',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Imei = 'imei',
  /** column name */
  Name = 'name',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Prefecture = 'prefecture',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "box" */
export type Box_Set_Input = {
  address?: Maybe<Scalars['String']>;
  coords?: Maybe<Scalars['geography']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  imei?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Prefecture_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** columns and relationships of "box_status" */
export type Box_Status = {
  __typename?: 'box_status';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  is_backup_battery?: Maybe<Scalars['Boolean']>;
  is_online: Scalars['Boolean'];
  is_open?: Maybe<Scalars['Boolean']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
  request_status?: Maybe<Unlock_Request_Type_Enum>;
  /** An object relationship */
  unlock_request_type?: Maybe<Unlock_Request_Type>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "box_status" */
export type Box_Status_Aggregate = {
  __typename?: 'box_status_aggregate';
  aggregate?: Maybe<Box_Status_Aggregate_Fields>;
  nodes: Array<Box_Status>;
};

/** aggregate fields of "box_status" */
export type Box_Status_Aggregate_Fields = {
  __typename?: 'box_status_aggregate_fields';
  avg?: Maybe<Box_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Box_Status_Max_Fields>;
  min?: Maybe<Box_Status_Min_Fields>;
  stddev?: Maybe<Box_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Box_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Box_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Box_Status_Sum_Fields>;
  var_pop?: Maybe<Box_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Box_Status_Var_Samp_Fields>;
  variance?: Maybe<Box_Status_Variance_Fields>;
};


/** aggregate fields of "box_status" */
export type Box_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Box_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "box_status" */
export type Box_Status_Aggregate_Order_By = {
  avg?: Maybe<Box_Status_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Box_Status_Max_Order_By>;
  min?: Maybe<Box_Status_Min_Order_By>;
  stddev?: Maybe<Box_Status_Stddev_Order_By>;
  stddev_pop?: Maybe<Box_Status_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Box_Status_Stddev_Samp_Order_By>;
  sum?: Maybe<Box_Status_Sum_Order_By>;
  var_pop?: Maybe<Box_Status_Var_Pop_Order_By>;
  var_samp?: Maybe<Box_Status_Var_Samp_Order_By>;
  variance?: Maybe<Box_Status_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "box_status" */
export type Box_Status_Arr_Rel_Insert_Input = {
  data: Array<Box_Status_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Box_Status_On_Conflict>;
};

/** aggregate avg on columns */
export type Box_Status_Avg_Fields = {
  __typename?: 'box_status_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "box_status" */
export type Box_Status_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "box_status". All fields are combined with a logical 'AND'. */
export type Box_Status_Bool_Exp = {
  _and?: Maybe<Array<Box_Status_Bool_Exp>>;
  _not?: Maybe<Box_Status_Bool_Exp>;
  _or?: Maybe<Array<Box_Status_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  is_backup_battery?: Maybe<Boolean_Comparison_Exp>;
  is_online?: Maybe<Boolean_Comparison_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  is_unlocked?: Maybe<Boolean_Comparison_Exp>;
  request_status?: Maybe<Unlock_Request_Type_Enum_Comparison_Exp>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "box_status" */
export enum Box_Status_Constraint {
  /** unique or primary key constraint on columns "box_id" */
  BoxStatusPkey = 'box_status_pkey'
}

/** input type for incrementing numeric columns in table "box_status" */
export type Box_Status_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "box_status" */
export type Box_Status_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
  is_online?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
  request_status?: Maybe<Unlock_Request_Type_Enum>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Box_Status_Max_Fields = {
  __typename?: 'box_status_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "box_status" */
export type Box_Status_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Box_Status_Min_Fields = {
  __typename?: 'box_status_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "box_status" */
export type Box_Status_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "box_status" */
export type Box_Status_Mutation_Response = {
  __typename?: 'box_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Box_Status>;
};

/** on_conflict condition type for table "box_status" */
export type Box_Status_On_Conflict = {
  constraint: Box_Status_Constraint;
  update_columns?: Array<Box_Status_Update_Column>;
  where?: Maybe<Box_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "box_status". */
export type Box_Status_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  is_backup_battery?: Maybe<Order_By>;
  is_online?: Maybe<Order_By>;
  is_open?: Maybe<Order_By>;
  is_unlocked?: Maybe<Order_By>;
  request_status?: Maybe<Order_By>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: box_status */
export type Box_Status_Pk_Columns_Input = {
  box_id: Scalars['Int'];
};

/** select columns of table "box_status" */
export enum Box_Status_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  IsBackupBattery = 'is_backup_battery',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsOpen = 'is_open',
  /** column name */
  IsUnlocked = 'is_unlocked',
  /** column name */
  RequestStatus = 'request_status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "box_status" */
export type Box_Status_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  is_backup_battery?: Maybe<Scalars['Boolean']>;
  is_online?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
  request_status?: Maybe<Unlock_Request_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Box_Status_Stddev_Fields = {
  __typename?: 'box_status_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "box_status" */
export type Box_Status_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Box_Status_Stddev_Pop_Fields = {
  __typename?: 'box_status_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "box_status" */
export type Box_Status_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Box_Status_Stddev_Samp_Fields = {
  __typename?: 'box_status_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "box_status" */
export type Box_Status_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Box_Status_Sum_Fields = {
  __typename?: 'box_status_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "box_status" */
export type Box_Status_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** update columns of table "box_status" */
export enum Box_Status_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  IsBackupBattery = 'is_backup_battery',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsOpen = 'is_open',
  /** column name */
  IsUnlocked = 'is_unlocked',
  /** column name */
  RequestStatus = 'request_status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Box_Status_Var_Pop_Fields = {
  __typename?: 'box_status_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "box_status" */
export type Box_Status_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Box_Status_Var_Samp_Fields = {
  __typename?: 'box_status_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "box_status" */
export type Box_Status_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Box_Status_Variance_Fields = {
  __typename?: 'box_status_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "box_status" */
export type Box_Status_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
};

/** aggregate stddev on columns */
export type Box_Stddev_Fields = {
  __typename?: 'box_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "box" */
export type Box_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Box_Stddev_Pop_Fields = {
  __typename?: 'box_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "box" */
export type Box_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Box_Stddev_Samp_Fields = {
  __typename?: 'box_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "box" */
export type Box_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Box_Sum_Fields = {
  __typename?: 'box_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "box" */
export type Box_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "box" */
export enum Box_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Coords = 'coords',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Imei = 'imei',
  /** column name */
  Name = 'name',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Prefecture = 'prefecture',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Box_Var_Pop_Fields = {
  __typename?: 'box_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "box" */
export type Box_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Box_Var_Samp_Fields = {
  __typename?: 'box_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "box" */
export type Box_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Box_Variance_Fields = {
  __typename?: 'box_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "box" */
export type Box_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "door_status_message" */
export type Door_Status_Message = {
  __typename?: 'door_status_message';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_open: Scalars['Boolean'];
};

/** aggregated selection of "door_status_message" */
export type Door_Status_Message_Aggregate = {
  __typename?: 'door_status_message_aggregate';
  aggregate?: Maybe<Door_Status_Message_Aggregate_Fields>;
  nodes: Array<Door_Status_Message>;
};

/** aggregate fields of "door_status_message" */
export type Door_Status_Message_Aggregate_Fields = {
  __typename?: 'door_status_message_aggregate_fields';
  avg?: Maybe<Door_Status_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Door_Status_Message_Max_Fields>;
  min?: Maybe<Door_Status_Message_Min_Fields>;
  stddev?: Maybe<Door_Status_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Door_Status_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Door_Status_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Door_Status_Message_Sum_Fields>;
  var_pop?: Maybe<Door_Status_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Door_Status_Message_Var_Samp_Fields>;
  variance?: Maybe<Door_Status_Message_Variance_Fields>;
};


/** aggregate fields of "door_status_message" */
export type Door_Status_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Door_Status_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "door_status_message" */
export type Door_Status_Message_Aggregate_Order_By = {
  avg?: Maybe<Door_Status_Message_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Door_Status_Message_Max_Order_By>;
  min?: Maybe<Door_Status_Message_Min_Order_By>;
  stddev?: Maybe<Door_Status_Message_Stddev_Order_By>;
  stddev_pop?: Maybe<Door_Status_Message_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Door_Status_Message_Stddev_Samp_Order_By>;
  sum?: Maybe<Door_Status_Message_Sum_Order_By>;
  var_pop?: Maybe<Door_Status_Message_Var_Pop_Order_By>;
  var_samp?: Maybe<Door_Status_Message_Var_Samp_Order_By>;
  variance?: Maybe<Door_Status_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "door_status_message" */
export type Door_Status_Message_Arr_Rel_Insert_Input = {
  data: Array<Door_Status_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Door_Status_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Door_Status_Message_Avg_Fields = {
  __typename?: 'door_status_message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "door_status_message" */
export type Door_Status_Message_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "door_status_message". All fields are combined with a logical 'AND'. */
export type Door_Status_Message_Bool_Exp = {
  _and?: Maybe<Array<Door_Status_Message_Bool_Exp>>;
  _not?: Maybe<Door_Status_Message_Bool_Exp>;
  _or?: Maybe<Array<Door_Status_Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "door_status_message" */
export enum Door_Status_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  DoorStatusMessagePkey = 'door_status_message_pkey'
}

/** input type for incrementing numeric columns in table "door_status_message" */
export type Door_Status_Message_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "door_status_message" */
export type Door_Status_Message_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_open?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Door_Status_Message_Max_Fields = {
  __typename?: 'door_status_message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "door_status_message" */
export type Door_Status_Message_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Door_Status_Message_Min_Fields = {
  __typename?: 'door_status_message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "door_status_message" */
export type Door_Status_Message_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "door_status_message" */
export type Door_Status_Message_Mutation_Response = {
  __typename?: 'door_status_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Door_Status_Message>;
};

/** on_conflict condition type for table "door_status_message" */
export type Door_Status_Message_On_Conflict = {
  constraint: Door_Status_Message_Constraint;
  update_columns?: Array<Door_Status_Message_Update_Column>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "door_status_message". */
export type Door_Status_Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_open?: Maybe<Order_By>;
};

/** primary key columns input for table: door_status_message */
export type Door_Status_Message_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "door_status_message" */
export enum Door_Status_Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpen = 'is_open'
}

/** input type for updating data in table "door_status_message" */
export type Door_Status_Message_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_open?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Door_Status_Message_Stddev_Fields = {
  __typename?: 'door_status_message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "door_status_message" */
export type Door_Status_Message_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Door_Status_Message_Stddev_Pop_Fields = {
  __typename?: 'door_status_message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "door_status_message" */
export type Door_Status_Message_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Door_Status_Message_Stddev_Samp_Fields = {
  __typename?: 'door_status_message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "door_status_message" */
export type Door_Status_Message_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Door_Status_Message_Sum_Fields = {
  __typename?: 'door_status_message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "door_status_message" */
export type Door_Status_Message_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "door_status_message" */
export enum Door_Status_Message_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpen = 'is_open'
}

/** aggregate var_pop on columns */
export type Door_Status_Message_Var_Pop_Fields = {
  __typename?: 'door_status_message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "door_status_message" */
export type Door_Status_Message_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Door_Status_Message_Var_Samp_Fields = {
  __typename?: 'door_status_message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "door_status_message" */
export type Door_Status_Message_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Door_Status_Message_Variance_Fields = {
  __typename?: 'door_status_message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "door_status_message" */
export type Door_Status_Message_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "employee" */
export type Employee = {
  __typename?: 'employee';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  zkt_id: Scalars['String'];
};

/** aggregated selection of "employee" */
export type Employee_Aggregate = {
  __typename?: 'employee_aggregate';
  aggregate?: Maybe<Employee_Aggregate_Fields>;
  nodes: Array<Employee>;
};

/** aggregate fields of "employee" */
export type Employee_Aggregate_Fields = {
  __typename?: 'employee_aggregate_fields';
  avg?: Maybe<Employee_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Employee_Max_Fields>;
  min?: Maybe<Employee_Min_Fields>;
  stddev?: Maybe<Employee_Stddev_Fields>;
  stddev_pop?: Maybe<Employee_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Employee_Stddev_Samp_Fields>;
  sum?: Maybe<Employee_Sum_Fields>;
  var_pop?: Maybe<Employee_Var_Pop_Fields>;
  var_samp?: Maybe<Employee_Var_Samp_Fields>;
  variance?: Maybe<Employee_Variance_Fields>;
};


/** aggregate fields of "employee" */
export type Employee_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Employee_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Employee_Avg_Fields = {
  __typename?: 'employee_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "employee". All fields are combined with a logical 'AND'. */
export type Employee_Bool_Exp = {
  _and?: Maybe<Array<Employee_Bool_Exp>>;
  _not?: Maybe<Employee_Bool_Exp>;
  _or?: Maybe<Array<Employee_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  zkt_id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "employee" */
export enum Employee_Constraint {
  /** unique or primary key constraint on columns "box_id" */
  EmployeeBoxIdKey = 'employee_box_id_key',
  /** unique or primary key constraint on columns "id" */
  EmployeePkey = 'employee_pkey',
  /** unique or primary key constraint on columns "zkt_id" */
  EmployeeZktIdKey = 'employee_zkt_id_key'
}

/** input type for incrementing numeric columns in table "employee" */
export type Employee_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "employee" */
export type Employee_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zkt_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Employee_Max_Fields = {
  __typename?: 'employee_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zkt_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Employee_Min_Fields = {
  __typename?: 'employee_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zkt_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "employee" */
export type Employee_Mutation_Response = {
  __typename?: 'employee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Employee>;
};

/** input type for inserting object relation for remote table "employee" */
export type Employee_Obj_Rel_Insert_Input = {
  data: Employee_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Employee_On_Conflict>;
};

/** on_conflict condition type for table "employee" */
export type Employee_On_Conflict = {
  constraint: Employee_Constraint;
  update_columns?: Array<Employee_Update_Column>;
  where?: Maybe<Employee_Bool_Exp>;
};

/** Ordering options when selecting data from "employee". */
export type Employee_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zkt_id?: Maybe<Order_By>;
};

/** primary key columns input for table: employee */
export type Employee_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "employee" */
export enum Employee_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZktId = 'zkt_id'
}

/** input type for updating data in table "employee" */
export type Employee_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zkt_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Employee_Stddev_Fields = {
  __typename?: 'employee_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Employee_Stddev_Pop_Fields = {
  __typename?: 'employee_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Employee_Stddev_Samp_Fields = {
  __typename?: 'employee_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Employee_Sum_Fields = {
  __typename?: 'employee_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "employee" */
export enum Employee_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZktId = 'zkt_id'
}

/** aggregate var_pop on columns */
export type Employee_Var_Pop_Fields = {
  __typename?: 'employee_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Employee_Var_Samp_Fields = {
  __typename?: 'employee_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Employee_Variance_Fields = {
  __typename?: 'employee_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};


export type Geography_Cast_Exp = {
  geometry?: Maybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: Maybe<Geography_Cast_Exp>;
  _eq?: Maybe<Scalars['geography']>;
  _gt?: Maybe<Scalars['geography']>;
  _gte?: Maybe<Scalars['geography']>;
  _in?: Maybe<Array<Scalars['geography']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geography']>;
  _lte?: Maybe<Scalars['geography']>;
  _neq?: Maybe<Scalars['geography']>;
  _nin?: Maybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: Maybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: Maybe<Scalars['geography']>;
};


export type Geometry_Cast_Exp = {
  geography?: Maybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: Maybe<Geometry_Cast_Exp>;
  _eq?: Maybe<Scalars['geometry']>;
  _gt?: Maybe<Scalars['geometry']>;
  _gte?: Maybe<Scalars['geometry']>;
  _in?: Maybe<Array<Scalars['geometry']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geometry']>;
  _lte?: Maybe<Scalars['geometry']>;
  _neq?: Maybe<Scalars['geometry']>;
  _nin?: Maybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: Maybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: Maybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: Maybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: Maybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: Maybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: Maybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: Maybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: Maybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: Maybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: Maybe<Scalars['geometry']>;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "key_status_message" */
export type Key_Status_Message = {
  __typename?: 'key_status_message';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_unlocked: Scalars['Boolean'];
};

/** aggregated selection of "key_status_message" */
export type Key_Status_Message_Aggregate = {
  __typename?: 'key_status_message_aggregate';
  aggregate?: Maybe<Key_Status_Message_Aggregate_Fields>;
  nodes: Array<Key_Status_Message>;
};

/** aggregate fields of "key_status_message" */
export type Key_Status_Message_Aggregate_Fields = {
  __typename?: 'key_status_message_aggregate_fields';
  avg?: Maybe<Key_Status_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Key_Status_Message_Max_Fields>;
  min?: Maybe<Key_Status_Message_Min_Fields>;
  stddev?: Maybe<Key_Status_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Key_Status_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Key_Status_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Key_Status_Message_Sum_Fields>;
  var_pop?: Maybe<Key_Status_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Key_Status_Message_Var_Samp_Fields>;
  variance?: Maybe<Key_Status_Message_Variance_Fields>;
};


/** aggregate fields of "key_status_message" */
export type Key_Status_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Key_Status_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "key_status_message" */
export type Key_Status_Message_Aggregate_Order_By = {
  avg?: Maybe<Key_Status_Message_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Key_Status_Message_Max_Order_By>;
  min?: Maybe<Key_Status_Message_Min_Order_By>;
  stddev?: Maybe<Key_Status_Message_Stddev_Order_By>;
  stddev_pop?: Maybe<Key_Status_Message_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Key_Status_Message_Stddev_Samp_Order_By>;
  sum?: Maybe<Key_Status_Message_Sum_Order_By>;
  var_pop?: Maybe<Key_Status_Message_Var_Pop_Order_By>;
  var_samp?: Maybe<Key_Status_Message_Var_Samp_Order_By>;
  variance?: Maybe<Key_Status_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "key_status_message" */
export type Key_Status_Message_Arr_Rel_Insert_Input = {
  data: Array<Key_Status_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Key_Status_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Key_Status_Message_Avg_Fields = {
  __typename?: 'key_status_message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "key_status_message" */
export type Key_Status_Message_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "key_status_message". All fields are combined with a logical 'AND'. */
export type Key_Status_Message_Bool_Exp = {
  _and?: Maybe<Array<Key_Status_Message_Bool_Exp>>;
  _not?: Maybe<Key_Status_Message_Bool_Exp>;
  _or?: Maybe<Array<Key_Status_Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_unlocked?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "key_status_message" */
export enum Key_Status_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  KeyStatusMessagePkey = 'key_status_message_pkey'
}

/** input type for incrementing numeric columns in table "key_status_message" */
export type Key_Status_Message_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "key_status_message" */
export type Key_Status_Message_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Key_Status_Message_Max_Fields = {
  __typename?: 'key_status_message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "key_status_message" */
export type Key_Status_Message_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Key_Status_Message_Min_Fields = {
  __typename?: 'key_status_message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "key_status_message" */
export type Key_Status_Message_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "key_status_message" */
export type Key_Status_Message_Mutation_Response = {
  __typename?: 'key_status_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Key_Status_Message>;
};

/** on_conflict condition type for table "key_status_message" */
export type Key_Status_Message_On_Conflict = {
  constraint: Key_Status_Message_Constraint;
  update_columns?: Array<Key_Status_Message_Update_Column>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "key_status_message". */
export type Key_Status_Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_unlocked?: Maybe<Order_By>;
};

/** primary key columns input for table: key_status_message */
export type Key_Status_Message_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "key_status_message" */
export enum Key_Status_Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsUnlocked = 'is_unlocked'
}

/** input type for updating data in table "key_status_message" */
export type Key_Status_Message_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  is_unlocked?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Key_Status_Message_Stddev_Fields = {
  __typename?: 'key_status_message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "key_status_message" */
export type Key_Status_Message_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Key_Status_Message_Stddev_Pop_Fields = {
  __typename?: 'key_status_message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "key_status_message" */
export type Key_Status_Message_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Key_Status_Message_Stddev_Samp_Fields = {
  __typename?: 'key_status_message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "key_status_message" */
export type Key_Status_Message_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Key_Status_Message_Sum_Fields = {
  __typename?: 'key_status_message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "key_status_message" */
export type Key_Status_Message_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "key_status_message" */
export enum Key_Status_Message_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsUnlocked = 'is_unlocked'
}

/** aggregate var_pop on columns */
export type Key_Status_Message_Var_Pop_Fields = {
  __typename?: 'key_status_message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "key_status_message" */
export type Key_Status_Message_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Key_Status_Message_Var_Samp_Fields = {
  __typename?: 'key_status_message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "key_status_message" */
export type Key_Status_Message_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Key_Status_Message_Variance_Fields = {
  __typename?: 'key_status_message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "key_status_message" */
export type Key_Status_Message_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "message" */
export type Message = {
  __typename?: 'message';
  /** An object relationship */
  box?: Maybe<Box>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "message" */
export type MessageValueArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "message" */
export type Message_Aggregate = {
  __typename?: 'message_aggregate';
  aggregate?: Maybe<Message_Aggregate_Fields>;
  nodes: Array<Message>;
};

/** aggregate fields of "message" */
export type Message_Aggregate_Fields = {
  __typename?: 'message_aggregate_fields';
  avg?: Maybe<Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Message_Max_Fields>;
  min?: Maybe<Message_Min_Fields>;
  stddev?: Maybe<Message_Stddev_Fields>;
  stddev_pop?: Maybe<Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Message_Stddev_Samp_Fields>;
  sum?: Maybe<Message_Sum_Fields>;
  var_pop?: Maybe<Message_Var_Pop_Fields>;
  var_samp?: Maybe<Message_Var_Samp_Fields>;
  variance?: Maybe<Message_Variance_Fields>;
};


/** aggregate fields of "message" */
export type Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Message_Avg_Fields = {
  __typename?: 'message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message". All fields are combined with a logical 'AND'. */
export type Message_Bool_Exp = {
  _and?: Maybe<Array<Message_Bool_Exp>>;
  _not?: Maybe<Message_Bool_Exp>;
  _or?: Maybe<Array<Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  value?: Maybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Message_Max_Fields = {
  __typename?: 'message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Message_Min_Fields = {
  __typename?: 'message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "message". */
export type Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** select columns of table "message" */
export enum Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Message_Stddev_Fields = {
  __typename?: 'message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Message_Stddev_Pop_Fields = {
  __typename?: 'message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Message_Stddev_Samp_Fields = {
  __typename?: 'message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Message_Sum_Fields = {
  __typename?: 'message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Message_Var_Pop_Fields = {
  __typename?: 'message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Message_Var_Samp_Fields = {
  __typename?: 'message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Message_Variance_Fields = {
  __typename?: 'message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "battery_status_message" */
  delete_battery_status_message?: Maybe<Battery_Status_Message_Mutation_Response>;
  /** delete single row from the table: "battery_status_message" */
  delete_battery_status_message_by_pk?: Maybe<Battery_Status_Message>;
  /** delete data from the table: "boot_regular_message" */
  delete_boot_regular_message?: Maybe<Boot_Regular_Message_Mutation_Response>;
  /** delete single row from the table: "boot_regular_message" */
  delete_boot_regular_message_by_pk?: Maybe<Boot_Regular_Message>;
  /** delete data from the table: "box" */
  delete_box?: Maybe<Box_Mutation_Response>;
  /** delete single row from the table: "box" */
  delete_box_by_pk?: Maybe<Box>;
  /** delete data from the table: "box_status" */
  delete_box_status?: Maybe<Box_Status_Mutation_Response>;
  /** delete single row from the table: "box_status" */
  delete_box_status_by_pk?: Maybe<Box_Status>;
  /** delete data from the table: "door_status_message" */
  delete_door_status_message?: Maybe<Door_Status_Message_Mutation_Response>;
  /** delete single row from the table: "door_status_message" */
  delete_door_status_message_by_pk?: Maybe<Door_Status_Message>;
  /** delete data from the table: "employee" */
  delete_employee?: Maybe<Employee_Mutation_Response>;
  /** delete single row from the table: "employee" */
  delete_employee_by_pk?: Maybe<Employee>;
  /** delete data from the table: "key_status_message" */
  delete_key_status_message?: Maybe<Key_Status_Message_Mutation_Response>;
  /** delete single row from the table: "key_status_message" */
  delete_key_status_message_by_pk?: Maybe<Key_Status_Message>;
  /** delete data from the table: "prefecture" */
  delete_prefecture?: Maybe<Prefecture_Mutation_Response>;
  /** delete single row from the table: "prefecture" */
  delete_prefecture_by_pk?: Maybe<Prefecture>;
  /** delete data from the table: "unlock_request_message" */
  delete_unlock_request_message?: Maybe<Unlock_Request_Message_Mutation_Response>;
  /** delete single row from the table: "unlock_request_message" */
  delete_unlock_request_message_by_pk?: Maybe<Unlock_Request_Message>;
  /** delete data from the table: "unlock_request_type" */
  delete_unlock_request_type?: Maybe<Unlock_Request_Type_Mutation_Response>;
  /** delete single row from the table: "unlock_request_type" */
  delete_unlock_request_type_by_pk?: Maybe<Unlock_Request_Type>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** insert data into the table: "battery_status_message" */
  insert_battery_status_message?: Maybe<Battery_Status_Message_Mutation_Response>;
  /** insert a single row into the table: "battery_status_message" */
  insert_battery_status_message_one?: Maybe<Battery_Status_Message>;
  /** insert data into the table: "boot_regular_message" */
  insert_boot_regular_message?: Maybe<Boot_Regular_Message_Mutation_Response>;
  /** insert a single row into the table: "boot_regular_message" */
  insert_boot_regular_message_one?: Maybe<Boot_Regular_Message>;
  /** insert data into the table: "box" */
  insert_box?: Maybe<Box_Mutation_Response>;
  /** insert a single row into the table: "box" */
  insert_box_one?: Maybe<Box>;
  /** insert data into the table: "box_status" */
  insert_box_status?: Maybe<Box_Status_Mutation_Response>;
  /** insert a single row into the table: "box_status" */
  insert_box_status_one?: Maybe<Box_Status>;
  /** insert data into the table: "door_status_message" */
  insert_door_status_message?: Maybe<Door_Status_Message_Mutation_Response>;
  /** insert a single row into the table: "door_status_message" */
  insert_door_status_message_one?: Maybe<Door_Status_Message>;
  /** insert data into the table: "employee" */
  insert_employee?: Maybe<Employee_Mutation_Response>;
  /** insert a single row into the table: "employee" */
  insert_employee_one?: Maybe<Employee>;
  /** insert data into the table: "key_status_message" */
  insert_key_status_message?: Maybe<Key_Status_Message_Mutation_Response>;
  /** insert a single row into the table: "key_status_message" */
  insert_key_status_message_one?: Maybe<Key_Status_Message>;
  /** insert data into the table: "prefecture" */
  insert_prefecture?: Maybe<Prefecture_Mutation_Response>;
  /** insert a single row into the table: "prefecture" */
  insert_prefecture_one?: Maybe<Prefecture>;
  /** insert data into the table: "unlock_request_message" */
  insert_unlock_request_message?: Maybe<Unlock_Request_Message_Mutation_Response>;
  /** insert a single row into the table: "unlock_request_message" */
  insert_unlock_request_message_one?: Maybe<Unlock_Request_Message>;
  /** insert data into the table: "unlock_request_type" */
  insert_unlock_request_type?: Maybe<Unlock_Request_Type_Mutation_Response>;
  /** insert a single row into the table: "unlock_request_type" */
  insert_unlock_request_type_one?: Maybe<Unlock_Request_Type>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  openBox?: Maybe<OpenBoxOutput>;
  /** update data of the table: "battery_status_message" */
  update_battery_status_message?: Maybe<Battery_Status_Message_Mutation_Response>;
  /** update single row of the table: "battery_status_message" */
  update_battery_status_message_by_pk?: Maybe<Battery_Status_Message>;
  /** update data of the table: "boot_regular_message" */
  update_boot_regular_message?: Maybe<Boot_Regular_Message_Mutation_Response>;
  /** update single row of the table: "boot_regular_message" */
  update_boot_regular_message_by_pk?: Maybe<Boot_Regular_Message>;
  /** update data of the table: "box" */
  update_box?: Maybe<Box_Mutation_Response>;
  /** update single row of the table: "box" */
  update_box_by_pk?: Maybe<Box>;
  /** update data of the table: "box_status" */
  update_box_status?: Maybe<Box_Status_Mutation_Response>;
  /** update single row of the table: "box_status" */
  update_box_status_by_pk?: Maybe<Box_Status>;
  /** update data of the table: "door_status_message" */
  update_door_status_message?: Maybe<Door_Status_Message_Mutation_Response>;
  /** update single row of the table: "door_status_message" */
  update_door_status_message_by_pk?: Maybe<Door_Status_Message>;
  /** update data of the table: "employee" */
  update_employee?: Maybe<Employee_Mutation_Response>;
  /** update single row of the table: "employee" */
  update_employee_by_pk?: Maybe<Employee>;
  /** update data of the table: "key_status_message" */
  update_key_status_message?: Maybe<Key_Status_Message_Mutation_Response>;
  /** update single row of the table: "key_status_message" */
  update_key_status_message_by_pk?: Maybe<Key_Status_Message>;
  /** update data of the table: "prefecture" */
  update_prefecture?: Maybe<Prefecture_Mutation_Response>;
  /** update single row of the table: "prefecture" */
  update_prefecture_by_pk?: Maybe<Prefecture>;
  /** update data of the table: "unlock_request_message" */
  update_unlock_request_message?: Maybe<Unlock_Request_Message_Mutation_Response>;
  /** update single row of the table: "unlock_request_message" */
  update_unlock_request_message_by_pk?: Maybe<Unlock_Request_Message>;
  /** update data of the table: "unlock_request_type" */
  update_unlock_request_type?: Maybe<Unlock_Request_Type_Mutation_Response>;
  /** update single row of the table: "unlock_request_type" */
  update_unlock_request_type_by_pk?: Maybe<Unlock_Request_Type>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
};


/** mutation root */
export type Mutation_RootDelete_Battery_Status_MessageArgs = {
  where: Battery_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Battery_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Boot_Regular_MessageArgs = {
  where: Boot_Regular_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Boot_Regular_Message_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BoxArgs = {
  where: Box_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Box_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Box_StatusArgs = {
  where: Box_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Box_Status_By_PkArgs = {
  box_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Door_Status_MessageArgs = {
  where: Door_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Door_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EmployeeArgs = {
  where: Employee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Employee_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Key_Status_MessageArgs = {
  where: Key_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Key_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PrefectureArgs = {
  where: Prefecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prefecture_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Unlock_Request_MessageArgs = {
  where: Unlock_Request_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unlock_Request_Message_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Unlock_Request_TypeArgs = {
  where: Unlock_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unlock_Request_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_Battery_Status_MessageArgs = {
  objects: Array<Battery_Status_Message_Insert_Input>;
  on_conflict?: Maybe<Battery_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Battery_Status_Message_OneArgs = {
  object: Battery_Status_Message_Insert_Input;
  on_conflict?: Maybe<Battery_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Boot_Regular_MessageArgs = {
  objects: Array<Boot_Regular_Message_Insert_Input>;
  on_conflict?: Maybe<Boot_Regular_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Boot_Regular_Message_OneArgs = {
  object: Boot_Regular_Message_Insert_Input;
  on_conflict?: Maybe<Boot_Regular_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BoxArgs = {
  objects: Array<Box_Insert_Input>;
  on_conflict?: Maybe<Box_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Box_OneArgs = {
  object: Box_Insert_Input;
  on_conflict?: Maybe<Box_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Box_StatusArgs = {
  objects: Array<Box_Status_Insert_Input>;
  on_conflict?: Maybe<Box_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Box_Status_OneArgs = {
  object: Box_Status_Insert_Input;
  on_conflict?: Maybe<Box_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Door_Status_MessageArgs = {
  objects: Array<Door_Status_Message_Insert_Input>;
  on_conflict?: Maybe<Door_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Door_Status_Message_OneArgs = {
  object: Door_Status_Message_Insert_Input;
  on_conflict?: Maybe<Door_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmployeeArgs = {
  objects: Array<Employee_Insert_Input>;
  on_conflict?: Maybe<Employee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Employee_OneArgs = {
  object: Employee_Insert_Input;
  on_conflict?: Maybe<Employee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Key_Status_MessageArgs = {
  objects: Array<Key_Status_Message_Insert_Input>;
  on_conflict?: Maybe<Key_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Key_Status_Message_OneArgs = {
  object: Key_Status_Message_Insert_Input;
  on_conflict?: Maybe<Key_Status_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PrefectureArgs = {
  objects: Array<Prefecture_Insert_Input>;
  on_conflict?: Maybe<Prefecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prefecture_OneArgs = {
  object: Prefecture_Insert_Input;
  on_conflict?: Maybe<Prefecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlock_Request_MessageArgs = {
  objects: Array<Unlock_Request_Message_Insert_Input>;
  on_conflict?: Maybe<Unlock_Request_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlock_Request_Message_OneArgs = {
  object: Unlock_Request_Message_Insert_Input;
  on_conflict?: Maybe<Unlock_Request_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlock_Request_TypeArgs = {
  objects: Array<Unlock_Request_Type_Insert_Input>;
  on_conflict?: Maybe<Unlock_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlock_Request_Type_OneArgs = {
  object: Unlock_Request_Type_Insert_Input;
  on_conflict?: Maybe<Unlock_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootOpenBoxArgs = {
  boxId: Scalars['Int'];
  imei: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Battery_Status_MessageArgs = {
  _inc?: Maybe<Battery_Status_Message_Inc_Input>;
  _set?: Maybe<Battery_Status_Message_Set_Input>;
  where: Battery_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Battery_Status_Message_By_PkArgs = {
  _inc?: Maybe<Battery_Status_Message_Inc_Input>;
  _set?: Maybe<Battery_Status_Message_Set_Input>;
  pk_columns: Battery_Status_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Boot_Regular_MessageArgs = {
  _inc?: Maybe<Boot_Regular_Message_Inc_Input>;
  _set?: Maybe<Boot_Regular_Message_Set_Input>;
  where: Boot_Regular_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Boot_Regular_Message_By_PkArgs = {
  _inc?: Maybe<Boot_Regular_Message_Inc_Input>;
  _set?: Maybe<Boot_Regular_Message_Set_Input>;
  pk_columns: Boot_Regular_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BoxArgs = {
  _inc?: Maybe<Box_Inc_Input>;
  _set?: Maybe<Box_Set_Input>;
  where: Box_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Box_By_PkArgs = {
  _inc?: Maybe<Box_Inc_Input>;
  _set?: Maybe<Box_Set_Input>;
  pk_columns: Box_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Box_StatusArgs = {
  _inc?: Maybe<Box_Status_Inc_Input>;
  _set?: Maybe<Box_Status_Set_Input>;
  where: Box_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Box_Status_By_PkArgs = {
  _inc?: Maybe<Box_Status_Inc_Input>;
  _set?: Maybe<Box_Status_Set_Input>;
  pk_columns: Box_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Door_Status_MessageArgs = {
  _inc?: Maybe<Door_Status_Message_Inc_Input>;
  _set?: Maybe<Door_Status_Message_Set_Input>;
  where: Door_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Door_Status_Message_By_PkArgs = {
  _inc?: Maybe<Door_Status_Message_Inc_Input>;
  _set?: Maybe<Door_Status_Message_Set_Input>;
  pk_columns: Door_Status_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EmployeeArgs = {
  _inc?: Maybe<Employee_Inc_Input>;
  _set?: Maybe<Employee_Set_Input>;
  where: Employee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Employee_By_PkArgs = {
  _inc?: Maybe<Employee_Inc_Input>;
  _set?: Maybe<Employee_Set_Input>;
  pk_columns: Employee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Key_Status_MessageArgs = {
  _inc?: Maybe<Key_Status_Message_Inc_Input>;
  _set?: Maybe<Key_Status_Message_Set_Input>;
  where: Key_Status_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Key_Status_Message_By_PkArgs = {
  _inc?: Maybe<Key_Status_Message_Inc_Input>;
  _set?: Maybe<Key_Status_Message_Set_Input>;
  pk_columns: Key_Status_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PrefectureArgs = {
  _set?: Maybe<Prefecture_Set_Input>;
  where: Prefecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prefecture_By_PkArgs = {
  _set?: Maybe<Prefecture_Set_Input>;
  pk_columns: Prefecture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unlock_Request_MessageArgs = {
  _inc?: Maybe<Unlock_Request_Message_Inc_Input>;
  _set?: Maybe<Unlock_Request_Message_Set_Input>;
  where: Unlock_Request_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unlock_Request_Message_By_PkArgs = {
  _inc?: Maybe<Unlock_Request_Message_Inc_Input>;
  _set?: Maybe<Unlock_Request_Message_Set_Input>;
  pk_columns: Unlock_Request_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unlock_Request_TypeArgs = {
  _set?: Maybe<Unlock_Request_Type_Set_Input>;
  where: Unlock_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unlock_Request_Type_By_PkArgs = {
  _set?: Maybe<Unlock_Request_Type_Set_Input>;
  pk_columns: Unlock_Request_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _set?: Maybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _set?: Maybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "prefecture" */
export type Prefecture = {
  __typename?: 'prefecture';
  /** An array relationship */
  boxes: Array<Box>;
  /** An aggregate relationship */
  boxes_aggregate: Box_Aggregate;
  name: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "prefecture" */
export type PrefectureBoxesArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


/** columns and relationships of "prefecture" */
export type PrefectureBoxes_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};

/** aggregated selection of "prefecture" */
export type Prefecture_Aggregate = {
  __typename?: 'prefecture_aggregate';
  aggregate?: Maybe<Prefecture_Aggregate_Fields>;
  nodes: Array<Prefecture>;
};

/** aggregate fields of "prefecture" */
export type Prefecture_Aggregate_Fields = {
  __typename?: 'prefecture_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Prefecture_Max_Fields>;
  min?: Maybe<Prefecture_Min_Fields>;
};


/** aggregate fields of "prefecture" */
export type Prefecture_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Prefecture_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "prefecture". All fields are combined with a logical 'AND'. */
export type Prefecture_Bool_Exp = {
  _and?: Maybe<Array<Prefecture_Bool_Exp>>;
  _not?: Maybe<Prefecture_Bool_Exp>;
  _or?: Maybe<Array<Prefecture_Bool_Exp>>;
  boxes?: Maybe<Box_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "prefecture" */
export enum Prefecture_Constraint {
  /** unique or primary key constraint on columns "value" */
  PrefecturePkey = 'prefecture_pkey'
}

export enum Prefecture_Enum {
  /** 愛知県 */
  Aichi = 'AICHI',
  /** 秋田県 */
  Akita = 'AKITA',
  /** 青森県 */
  Aomori = 'AOMORI',
  /** 千葉県 */
  Chiba = 'CHIBA',
  /** 愛媛県 */
  Ehime = 'EHIME',
  /** 福井県 */
  Fukui = 'FUKUI',
  /** 福岡県 */
  Fukuoka = 'FUKUOKA',
  /** 福島県 */
  Fukushima = 'FUKUSHIMA',
  /** 岐阜県 */
  Gifu = 'GIFU',
  /** 群馬県 */
  Gunma = 'GUNMA',
  /** 広島県 */
  Hiroshima = 'HIROSHIMA',
  /** 北海道 */
  Hokkaido = 'HOKKAIDO',
  /** 兵庫県 */
  Hyogo = 'HYOGO',
  /** 茨城県 */
  Ibaraki = 'IBARAKI',
  /** 石川県 */
  Ishikawa = 'ISHIKAWA',
  /** 岩手県 */
  Iwate = 'IWATE',
  /** 香川県 */
  Kagawa = 'KAGAWA',
  /** 鹿児島県 */
  Kagoshima = 'KAGOSHIMA',
  /** 神奈川県 */
  Kanagawa = 'KANAGAWA',
  /** 高知県 */
  Kochi = 'KOCHI',
  /** 熊本県 */
  Kumamoto = 'KUMAMOTO',
  /** 京都府 */
  Kyoto = 'KYOTO',
  /** 三重県 */
  Mie = 'MIE',
  /** 宮城県 */
  Miyagi = 'MIYAGI',
  /** 宮崎県 */
  Miyazaki = 'MIYAZAKI',
  /** 長野県 */
  Nagano = 'NAGANO',
  /** 長崎県 */
  Nagasaki = 'NAGASAKI',
  /** 奈良県 */
  Nara = 'NARA',
  /** 新潟県 */
  Niigata = 'NIIGATA',
  /** 大分県 */
  Oita = 'OITA',
  /** 岡山県 */
  Okayama = 'OKAYAMA',
  /** 沖縄県 */
  Okinawa = 'OKINAWA',
  /** 大阪府 */
  Osaka = 'OSAKA',
  /** 佐賀県 */
  Saga = 'SAGA',
  /** 埼玉県 */
  Saitama = 'SAITAMA',
  /** 滋賀県 */
  Shiga = 'SHIGA',
  /** 島根県 */
  Shimane = 'SHIMANE',
  /** 静岡県 */
  Shizuoka = 'SHIZUOKA',
  /** 栃木県 */
  Tochigi = 'TOCHIGI',
  /** 徳島県 */
  Tokushima = 'TOKUSHIMA',
  /** 東京都 */
  Tokyo = 'TOKYO',
  /** 鳥取県 */
  Tottori = 'TOTTORI',
  /** 富山県 */
  Toyama = 'TOYAMA',
  /** 和歌山県 */
  Wakayama = 'WAKAYAMA',
  /** 山形県 */
  Yamagata = 'YAMAGATA',
  /** 山口県 */
  Yamaguchi = 'YAMAGUCHI',
  /** 山梨県 */
  Yamanashi = 'YAMANASHI'
}

/** Boolean expression to compare columns of type "prefecture_enum". All fields are combined with logical 'AND'. */
export type Prefecture_Enum_Comparison_Exp = {
  _eq?: Maybe<Prefecture_Enum>;
  _in?: Maybe<Array<Prefecture_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Prefecture_Enum>;
  _nin?: Maybe<Array<Prefecture_Enum>>;
};

/** input type for inserting data into table "prefecture" */
export type Prefecture_Insert_Input = {
  boxes?: Maybe<Box_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Prefecture_Max_Fields = {
  __typename?: 'prefecture_max_fields';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Prefecture_Min_Fields = {
  __typename?: 'prefecture_min_fields';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "prefecture" */
export type Prefecture_Mutation_Response = {
  __typename?: 'prefecture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prefecture>;
};

/** input type for inserting object relation for remote table "prefecture" */
export type Prefecture_Obj_Rel_Insert_Input = {
  data: Prefecture_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Prefecture_On_Conflict>;
};

/** on_conflict condition type for table "prefecture" */
export type Prefecture_On_Conflict = {
  constraint: Prefecture_Constraint;
  update_columns?: Array<Prefecture_Update_Column>;
  where?: Maybe<Prefecture_Bool_Exp>;
};

/** Ordering options when selecting data from "prefecture". */
export type Prefecture_Order_By = {
  boxes_aggregate?: Maybe<Box_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: prefecture */
export type Prefecture_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "prefecture" */
export enum Prefecture_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "prefecture" */
export type Prefecture_Set_Input = {
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "prefecture" */
export enum Prefecture_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "battery_status_message" */
  battery_status_message: Array<Battery_Status_Message>;
  /** fetch aggregated fields from the table: "battery_status_message" */
  battery_status_message_aggregate: Battery_Status_Message_Aggregate;
  /** fetch data from the table: "battery_status_message" using primary key columns */
  battery_status_message_by_pk?: Maybe<Battery_Status_Message>;
  /** fetch data from the table: "boot_regular_message" */
  boot_regular_message: Array<Boot_Regular_Message>;
  /** fetch aggregated fields from the table: "boot_regular_message" */
  boot_regular_message_aggregate: Boot_Regular_Message_Aggregate;
  /** fetch data from the table: "boot_regular_message" using primary key columns */
  boot_regular_message_by_pk?: Maybe<Boot_Regular_Message>;
  /** fetch data from the table: "box" */
  box: Array<Box>;
  /** fetch aggregated fields from the table: "box" */
  box_aggregate: Box_Aggregate;
  /** fetch data from the table: "box" using primary key columns */
  box_by_pk?: Maybe<Box>;
  /** fetch data from the table: "box_status" */
  box_status: Array<Box_Status>;
  /** fetch aggregated fields from the table: "box_status" */
  box_status_aggregate: Box_Status_Aggregate;
  /** fetch data from the table: "box_status" using primary key columns */
  box_status_by_pk?: Maybe<Box_Status>;
  /** fetch data from the table: "door_status_message" */
  door_status_message: Array<Door_Status_Message>;
  /** fetch aggregated fields from the table: "door_status_message" */
  door_status_message_aggregate: Door_Status_Message_Aggregate;
  /** fetch data from the table: "door_status_message" using primary key columns */
  door_status_message_by_pk?: Maybe<Door_Status_Message>;
  /** fetch data from the table: "employee" */
  employee: Array<Employee>;
  /** fetch aggregated fields from the table: "employee" */
  employee_aggregate: Employee_Aggregate;
  /** fetch data from the table: "employee" using primary key columns */
  employee_by_pk?: Maybe<Employee>;
  geocodeAddress?: Maybe<Coords>;
  /** fetch data from the table: "key_status_message" */
  key_status_message: Array<Key_Status_Message>;
  /** fetch aggregated fields from the table: "key_status_message" */
  key_status_message_aggregate: Key_Status_Message_Aggregate;
  /** fetch data from the table: "key_status_message" using primary key columns */
  key_status_message_by_pk?: Maybe<Key_Status_Message>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "prefecture" */
  prefecture: Array<Prefecture>;
  /** fetch aggregated fields from the table: "prefecture" */
  prefecture_aggregate: Prefecture_Aggregate;
  /** fetch data from the table: "prefecture" using primary key columns */
  prefecture_by_pk?: Maybe<Prefecture>;
  /** fetch data from the table: "unlock_request_message" */
  unlock_request_message: Array<Unlock_Request_Message>;
  /** fetch aggregated fields from the table: "unlock_request_message" */
  unlock_request_message_aggregate: Unlock_Request_Message_Aggregate;
  /** fetch data from the table: "unlock_request_message" using primary key columns */
  unlock_request_message_by_pk?: Maybe<Unlock_Request_Message>;
  /** fetch data from the table: "unlock_request_type" */
  unlock_request_type: Array<Unlock_Request_Type>;
  /** fetch aggregated fields from the table: "unlock_request_type" */
  unlock_request_type_aggregate: Unlock_Request_Type_Aggregate;
  /** fetch data from the table: "unlock_request_type" using primary key columns */
  unlock_request_type_by_pk?: Maybe<Unlock_Request_Type>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};


export type Query_RootBattery_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


export type Query_RootBattery_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


export type Query_RootBattery_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBoot_Regular_MessageArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


export type Query_RootBoot_Regular_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


export type Query_RootBoot_Regular_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBoxArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


export type Query_RootBox_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


export type Query_RootBox_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBox_StatusArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


export type Query_RootBox_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


export type Query_RootBox_Status_By_PkArgs = {
  box_id: Scalars['Int'];
};


export type Query_RootDoor_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


export type Query_RootDoor_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


export type Query_RootDoor_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEmployeeArgs = {
  distinct_on?: Maybe<Array<Employee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employee_Order_By>>;
  where?: Maybe<Employee_Bool_Exp>;
};


export type Query_RootEmployee_AggregateArgs = {
  distinct_on?: Maybe<Array<Employee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employee_Order_By>>;
  where?: Maybe<Employee_Bool_Exp>;
};


export type Query_RootEmployee_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGeocodeAddressArgs = {
  address: Scalars['String'];
};


export type Query_RootKey_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


export type Query_RootKey_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


export type Query_RootKey_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMessageArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Query_RootMessage_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Query_RootPrefectureArgs = {
  distinct_on?: Maybe<Array<Prefecture_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prefecture_Order_By>>;
  where?: Maybe<Prefecture_Bool_Exp>;
};


export type Query_RootPrefecture_AggregateArgs = {
  distinct_on?: Maybe<Array<Prefecture_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prefecture_Order_By>>;
  where?: Maybe<Prefecture_Bool_Exp>;
};


export type Query_RootPrefecture_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUnlock_Request_MessageArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


export type Query_RootUnlock_Request_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


export type Query_RootUnlock_Request_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUnlock_Request_TypeArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Type_Order_By>>;
  where?: Maybe<Unlock_Request_Type_Bool_Exp>;
};


export type Query_RootUnlock_Request_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Type_Order_By>>;
  where?: Maybe<Unlock_Request_Type_Bool_Exp>;
};


export type Query_RootUnlock_Request_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['String'];
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: Maybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "battery_status_message" */
  battery_status_message: Array<Battery_Status_Message>;
  /** fetch aggregated fields from the table: "battery_status_message" */
  battery_status_message_aggregate: Battery_Status_Message_Aggregate;
  /** fetch data from the table: "battery_status_message" using primary key columns */
  battery_status_message_by_pk?: Maybe<Battery_Status_Message>;
  /** fetch data from the table: "boot_regular_message" */
  boot_regular_message: Array<Boot_Regular_Message>;
  /** fetch aggregated fields from the table: "boot_regular_message" */
  boot_regular_message_aggregate: Boot_Regular_Message_Aggregate;
  /** fetch data from the table: "boot_regular_message" using primary key columns */
  boot_regular_message_by_pk?: Maybe<Boot_Regular_Message>;
  /** fetch data from the table: "box" */
  box: Array<Box>;
  /** fetch aggregated fields from the table: "box" */
  box_aggregate: Box_Aggregate;
  /** fetch data from the table: "box" using primary key columns */
  box_by_pk?: Maybe<Box>;
  /** fetch data from the table: "box_status" */
  box_status: Array<Box_Status>;
  /** fetch aggregated fields from the table: "box_status" */
  box_status_aggregate: Box_Status_Aggregate;
  /** fetch data from the table: "box_status" using primary key columns */
  box_status_by_pk?: Maybe<Box_Status>;
  /** fetch data from the table: "door_status_message" */
  door_status_message: Array<Door_Status_Message>;
  /** fetch aggregated fields from the table: "door_status_message" */
  door_status_message_aggregate: Door_Status_Message_Aggregate;
  /** fetch data from the table: "door_status_message" using primary key columns */
  door_status_message_by_pk?: Maybe<Door_Status_Message>;
  /** fetch data from the table: "employee" */
  employee: Array<Employee>;
  /** fetch aggregated fields from the table: "employee" */
  employee_aggregate: Employee_Aggregate;
  /** fetch data from the table: "employee" using primary key columns */
  employee_by_pk?: Maybe<Employee>;
  /** fetch data from the table: "key_status_message" */
  key_status_message: Array<Key_Status_Message>;
  /** fetch aggregated fields from the table: "key_status_message" */
  key_status_message_aggregate: Key_Status_Message_Aggregate;
  /** fetch data from the table: "key_status_message" using primary key columns */
  key_status_message_by_pk?: Maybe<Key_Status_Message>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "prefecture" */
  prefecture: Array<Prefecture>;
  /** fetch aggregated fields from the table: "prefecture" */
  prefecture_aggregate: Prefecture_Aggregate;
  /** fetch data from the table: "prefecture" using primary key columns */
  prefecture_by_pk?: Maybe<Prefecture>;
  /** fetch data from the table: "unlock_request_message" */
  unlock_request_message: Array<Unlock_Request_Message>;
  /** fetch aggregated fields from the table: "unlock_request_message" */
  unlock_request_message_aggregate: Unlock_Request_Message_Aggregate;
  /** fetch data from the table: "unlock_request_message" using primary key columns */
  unlock_request_message_by_pk?: Maybe<Unlock_Request_Message>;
  /** fetch data from the table: "unlock_request_type" */
  unlock_request_type: Array<Unlock_Request_Type>;
  /** fetch aggregated fields from the table: "unlock_request_type" */
  unlock_request_type_aggregate: Unlock_Request_Type_Aggregate;
  /** fetch data from the table: "unlock_request_type" using primary key columns */
  unlock_request_type_by_pk?: Maybe<Unlock_Request_Type>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};


export type Subscription_RootBattery_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


export type Subscription_RootBattery_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Battery_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Battery_Status_Message_Order_By>>;
  where?: Maybe<Battery_Status_Message_Bool_Exp>;
};


export type Subscription_RootBattery_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBoot_Regular_MessageArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


export type Subscription_RootBoot_Regular_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Boot_Regular_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Boot_Regular_Message_Order_By>>;
  where?: Maybe<Boot_Regular_Message_Bool_Exp>;
};


export type Subscription_RootBoot_Regular_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBoxArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


export type Subscription_RootBox_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


export type Subscription_RootBox_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBox_StatusArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


export type Subscription_RootBox_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


export type Subscription_RootBox_Status_By_PkArgs = {
  box_id: Scalars['Int'];
};


export type Subscription_RootDoor_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


export type Subscription_RootDoor_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Door_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Door_Status_Message_Order_By>>;
  where?: Maybe<Door_Status_Message_Bool_Exp>;
};


export type Subscription_RootDoor_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEmployeeArgs = {
  distinct_on?: Maybe<Array<Employee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employee_Order_By>>;
  where?: Maybe<Employee_Bool_Exp>;
};


export type Subscription_RootEmployee_AggregateArgs = {
  distinct_on?: Maybe<Array<Employee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employee_Order_By>>;
  where?: Maybe<Employee_Bool_Exp>;
};


export type Subscription_RootEmployee_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootKey_Status_MessageArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


export type Subscription_RootKey_Status_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Key_Status_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Key_Status_Message_Order_By>>;
  where?: Maybe<Key_Status_Message_Bool_Exp>;
};


export type Subscription_RootKey_Status_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMessageArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Subscription_RootMessage_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Subscription_RootPrefectureArgs = {
  distinct_on?: Maybe<Array<Prefecture_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prefecture_Order_By>>;
  where?: Maybe<Prefecture_Bool_Exp>;
};


export type Subscription_RootPrefecture_AggregateArgs = {
  distinct_on?: Maybe<Array<Prefecture_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prefecture_Order_By>>;
  where?: Maybe<Prefecture_Bool_Exp>;
};


export type Subscription_RootPrefecture_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUnlock_Request_MessageArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


export type Subscription_RootUnlock_Request_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


export type Subscription_RootUnlock_Request_Message_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUnlock_Request_TypeArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Type_Order_By>>;
  where?: Maybe<Unlock_Request_Type_Bool_Exp>;
};


export type Subscription_RootUnlock_Request_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Type_Order_By>>;
  where?: Maybe<Unlock_Request_Type_Bool_Exp>;
};


export type Subscription_RootUnlock_Request_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['String'];
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "unlock_request_message" */
export type Unlock_Request_Message = {
  __typename?: 'unlock_request_message';
  /** An object relationship */
  box: Box;
  box_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  type: Unlock_Request_Type_Enum;
  /** An object relationship */
  unlock_request_type: Unlock_Request_Type;
};

/** aggregated selection of "unlock_request_message" */
export type Unlock_Request_Message_Aggregate = {
  __typename?: 'unlock_request_message_aggregate';
  aggregate?: Maybe<Unlock_Request_Message_Aggregate_Fields>;
  nodes: Array<Unlock_Request_Message>;
};

/** aggregate fields of "unlock_request_message" */
export type Unlock_Request_Message_Aggregate_Fields = {
  __typename?: 'unlock_request_message_aggregate_fields';
  avg?: Maybe<Unlock_Request_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unlock_Request_Message_Max_Fields>;
  min?: Maybe<Unlock_Request_Message_Min_Fields>;
  stddev?: Maybe<Unlock_Request_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Unlock_Request_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unlock_Request_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Unlock_Request_Message_Sum_Fields>;
  var_pop?: Maybe<Unlock_Request_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Unlock_Request_Message_Var_Samp_Fields>;
  variance?: Maybe<Unlock_Request_Message_Variance_Fields>;
};


/** aggregate fields of "unlock_request_message" */
export type Unlock_Request_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unlock_request_message" */
export type Unlock_Request_Message_Aggregate_Order_By = {
  avg?: Maybe<Unlock_Request_Message_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Unlock_Request_Message_Max_Order_By>;
  min?: Maybe<Unlock_Request_Message_Min_Order_By>;
  stddev?: Maybe<Unlock_Request_Message_Stddev_Order_By>;
  stddev_pop?: Maybe<Unlock_Request_Message_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Unlock_Request_Message_Stddev_Samp_Order_By>;
  sum?: Maybe<Unlock_Request_Message_Sum_Order_By>;
  var_pop?: Maybe<Unlock_Request_Message_Var_Pop_Order_By>;
  var_samp?: Maybe<Unlock_Request_Message_Var_Samp_Order_By>;
  variance?: Maybe<Unlock_Request_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unlock_request_message" */
export type Unlock_Request_Message_Arr_Rel_Insert_Input = {
  data: Array<Unlock_Request_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Unlock_Request_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Unlock_Request_Message_Avg_Fields = {
  __typename?: 'unlock_request_message_avg_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Avg_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unlock_request_message". All fields are combined with a logical 'AND'. */
export type Unlock_Request_Message_Bool_Exp = {
  _and?: Maybe<Array<Unlock_Request_Message_Bool_Exp>>;
  _not?: Maybe<Unlock_Request_Message_Bool_Exp>;
  _or?: Maybe<Array<Unlock_Request_Message_Bool_Exp>>;
  box?: Maybe<Box_Bool_Exp>;
  box_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  type?: Maybe<Unlock_Request_Type_Enum_Comparison_Exp>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "unlock_request_message" */
export enum Unlock_Request_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnlockRequestMessagePkey = 'unlock_request_message_pkey'
}

/** input type for incrementing numeric columns in table "unlock_request_message" */
export type Unlock_Request_Message_Inc_Input = {
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "unlock_request_message" */
export type Unlock_Request_Message_Insert_Input = {
  box?: Maybe<Box_Obj_Rel_Insert_Input>;
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Unlock_Request_Type_Enum>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unlock_Request_Message_Max_Fields = {
  __typename?: 'unlock_request_message_max_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Max_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Unlock_Request_Message_Min_Fields = {
  __typename?: 'unlock_request_message_min_fields';
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Min_Order_By = {
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "unlock_request_message" */
export type Unlock_Request_Message_Mutation_Response = {
  __typename?: 'unlock_request_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unlock_Request_Message>;
};

/** on_conflict condition type for table "unlock_request_message" */
export type Unlock_Request_Message_On_Conflict = {
  constraint: Unlock_Request_Message_Constraint;
  update_columns?: Array<Unlock_Request_Message_Update_Column>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "unlock_request_message". */
export type Unlock_Request_Message_Order_By = {
  box?: Maybe<Box_Order_By>;
  box_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  unlock_request_type?: Maybe<Unlock_Request_Type_Order_By>;
};

/** primary key columns input for table: unlock_request_message */
export type Unlock_Request_Message_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "unlock_request_message" */
export enum Unlock_Request_Message_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "unlock_request_message" */
export type Unlock_Request_Message_Set_Input = {
  box_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Unlock_Request_Type_Enum>;
};

/** aggregate stddev on columns */
export type Unlock_Request_Message_Stddev_Fields = {
  __typename?: 'unlock_request_message_stddev_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Stddev_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unlock_Request_Message_Stddev_Pop_Fields = {
  __typename?: 'unlock_request_message_stddev_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Stddev_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unlock_Request_Message_Stddev_Samp_Fields = {
  __typename?: 'unlock_request_message_stddev_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Stddev_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Unlock_Request_Message_Sum_Fields = {
  __typename?: 'unlock_request_message_sum_fields';
  box_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Sum_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "unlock_request_message" */
export enum Unlock_Request_Message_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** aggregate var_pop on columns */
export type Unlock_Request_Message_Var_Pop_Fields = {
  __typename?: 'unlock_request_message_var_pop_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Var_Pop_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unlock_Request_Message_Var_Samp_Fields = {
  __typename?: 'unlock_request_message_var_samp_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Var_Samp_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Unlock_Request_Message_Variance_Fields = {
  __typename?: 'unlock_request_message_variance_fields';
  box_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unlock_request_message" */
export type Unlock_Request_Message_Variance_Order_By = {
  box_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "unlock_request_type" */
export type Unlock_Request_Type = {
  __typename?: 'unlock_request_type';
  /** An array relationship */
  box_statuses: Array<Box_Status>;
  /** An aggregate relationship */
  box_statuses_aggregate: Box_Status_Aggregate;
  description: Scalars['String'];
  type: Scalars['String'];
  /** An array relationship */
  unlock_request_messages: Array<Unlock_Request_Message>;
  /** An aggregate relationship */
  unlock_request_messages_aggregate: Unlock_Request_Message_Aggregate;
};


/** columns and relationships of "unlock_request_type" */
export type Unlock_Request_TypeBox_StatusesArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


/** columns and relationships of "unlock_request_type" */
export type Unlock_Request_TypeBox_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Status_Order_By>>;
  where?: Maybe<Box_Status_Bool_Exp>;
};


/** columns and relationships of "unlock_request_type" */
export type Unlock_Request_TypeUnlock_Request_MessagesArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};


/** columns and relationships of "unlock_request_type" */
export type Unlock_Request_TypeUnlock_Request_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Unlock_Request_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unlock_Request_Message_Order_By>>;
  where?: Maybe<Unlock_Request_Message_Bool_Exp>;
};

/** aggregated selection of "unlock_request_type" */
export type Unlock_Request_Type_Aggregate = {
  __typename?: 'unlock_request_type_aggregate';
  aggregate?: Maybe<Unlock_Request_Type_Aggregate_Fields>;
  nodes: Array<Unlock_Request_Type>;
};

/** aggregate fields of "unlock_request_type" */
export type Unlock_Request_Type_Aggregate_Fields = {
  __typename?: 'unlock_request_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Unlock_Request_Type_Max_Fields>;
  min?: Maybe<Unlock_Request_Type_Min_Fields>;
};


/** aggregate fields of "unlock_request_type" */
export type Unlock_Request_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Unlock_Request_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "unlock_request_type". All fields are combined with a logical 'AND'. */
export type Unlock_Request_Type_Bool_Exp = {
  _and?: Maybe<Array<Unlock_Request_Type_Bool_Exp>>;
  _not?: Maybe<Unlock_Request_Type_Bool_Exp>;
  _or?: Maybe<Array<Unlock_Request_Type_Bool_Exp>>;
  box_statuses?: Maybe<Box_Status_Bool_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  unlock_request_messages?: Maybe<Unlock_Request_Message_Bool_Exp>;
};

/** unique or primary key constraints on table "unlock_request_type" */
export enum Unlock_Request_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  UnlockRequestTypePkey = 'unlock_request_type_pkey'
}

export enum Unlock_Request_Type_Enum {
  /** 受信データエラー */
  ReceiveError = 'RECEIVE_ERROR',
  /** 要求 */
  Request = 'REQUEST',
  /** 正常 */
  Success = 'SUCCESS',
  /** タイムアウト */
  Timeout = 'TIMEOUT',
  /** 解錠制御エラー */
  UnlockError = 'UNLOCK_ERROR'
}

/** Boolean expression to compare columns of type "unlock_request_type_enum". All fields are combined with logical 'AND'. */
export type Unlock_Request_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Unlock_Request_Type_Enum>;
  _in?: Maybe<Array<Unlock_Request_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Unlock_Request_Type_Enum>;
  _nin?: Maybe<Array<Unlock_Request_Type_Enum>>;
};

/** input type for inserting data into table "unlock_request_type" */
export type Unlock_Request_Type_Insert_Input = {
  box_statuses?: Maybe<Box_Status_Arr_Rel_Insert_Input>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unlock_request_messages?: Maybe<Unlock_Request_Message_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unlock_Request_Type_Max_Fields = {
  __typename?: 'unlock_request_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unlock_Request_Type_Min_Fields = {
  __typename?: 'unlock_request_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unlock_request_type" */
export type Unlock_Request_Type_Mutation_Response = {
  __typename?: 'unlock_request_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unlock_Request_Type>;
};

/** input type for inserting object relation for remote table "unlock_request_type" */
export type Unlock_Request_Type_Obj_Rel_Insert_Input = {
  data: Unlock_Request_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Unlock_Request_Type_On_Conflict>;
};

/** on_conflict condition type for table "unlock_request_type" */
export type Unlock_Request_Type_On_Conflict = {
  constraint: Unlock_Request_Type_Constraint;
  update_columns?: Array<Unlock_Request_Type_Update_Column>;
  where?: Maybe<Unlock_Request_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "unlock_request_type". */
export type Unlock_Request_Type_Order_By = {
  box_statuses_aggregate?: Maybe<Box_Status_Aggregate_Order_By>;
  description?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  unlock_request_messages_aggregate?: Maybe<Unlock_Request_Message_Aggregate_Order_By>;
};

/** primary key columns input for table: unlock_request_type */
export type Unlock_Request_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "unlock_request_type" */
export enum Unlock_Request_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "unlock_request_type" */
export type Unlock_Request_Type_Set_Input = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "unlock_request_type" */
export enum Unlock_Request_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  /** An array relationship */
  boxes: Array<Box>;
  /** An aggregate relationship */
  boxes_aggregate: Box_Aggregate;
  email: Scalars['String'];
  id: Scalars['String'];
};


/** columns and relationships of "user" */
export type UserBoxesArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserBoxes_AggregateArgs = {
  distinct_on?: Maybe<Array<Box_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Box_Order_By>>;
  where?: Maybe<Box_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: Maybe<Array<User_Bool_Exp>>;
  _not?: Maybe<User_Bool_Exp>;
  _or?: Maybe<Array<User_Bool_Exp>>;
  boxes?: Maybe<Box_Bool_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  boxes?: Maybe<Box_Arr_Rel_Insert_Input>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: Maybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  boxes_aggregate?: Maybe<Box_Aggregate_Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id'
}

export type AdminBoxFragment = (
  { __typename?: 'box' }
  & Pick<Box, 'plate_number' | 'address' | 'postcode' | 'prefecture'>
  & { prefectureByPrefecture?: Maybe<(
    { __typename?: 'prefecture' }
    & Pick<Prefecture, 'name'>
  )> }
  & BoxFragment
);

export type AdminBoxesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminBoxesQuery = (
  { __typename?: 'query_root' }
  & { box: Array<(
    { __typename?: 'box' }
    & AdminBoxFragment
  )>, box_aggregate: (
    { __typename?: 'box_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'box_aggregate_fields' }
      & Pick<Box_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type DeleteAdminBoxesMutationVariables = Exact<{
  boxIds?: Maybe<Array<Scalars['Int']>>;
}>;


export type DeleteAdminBoxesMutation = (
  { __typename?: 'mutation_root' }
  & { delete_box?: Maybe<(
    { __typename?: 'box_mutation_response' }
    & { returning: Array<(
      { __typename?: 'box' }
      & Pick<Box, 'id' | 'imei'>
    )> }
  )> }
);

export type PrefectureFragment = (
  { __typename?: 'prefecture' }
  & Pick<Prefecture, 'value' | 'name'>
);

export type PrefecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type PrefecturesQuery = (
  { __typename?: 'query_root' }
  & { prefecture: Array<(
    { __typename?: 'prefecture' }
    & PrefectureFragment
  )> }
);

export type GeocodeAddressQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type GeocodeAddressQuery = (
  { __typename?: 'query_root' }
  & { geocodeAddress?: Maybe<(
    { __typename?: 'Coords' }
    & Pick<Coords, 'lat' | 'lng'>
  )> }
);

export type UpsertAdminBoxMutationVariables = Exact<{
  box: Box_Insert_Input;
}>;


export type UpsertAdminBoxMutation = (
  { __typename?: 'mutation_root' }
  & { insert_box_one?: Maybe<(
    { __typename?: 'box' }
    & Pick<Box, 'id' | 'imei'>
  )> }
);

export type UpdateAdminBoxMutationVariables = Exact<{
  boxId: Scalars['Int'];
  box: Box_Set_Input;
}>;


export type UpdateAdminBoxMutation = (
  { __typename?: 'mutation_root' }
  & { update_box_by_pk?: Maybe<(
    { __typename?: 'box' }
    & Pick<Box, 'id' | 'imei'>
  )> }
);

export type UnlockBoxMutationVariables = Exact<{
  boxId: Scalars['Int'];
  imei: Scalars['String'];
}>;


export type UnlockBoxMutation = (
  { __typename?: 'mutation_root' }
  & { openBox?: Maybe<(
    { __typename?: 'OpenBoxOutput' }
    & Pick<OpenBoxOutput, 'id' | 'box_id' | 'created_at'>
  )> }
);

export type BoxStatusFragment = (
  { __typename?: 'box_status' }
  & Pick<Box_Status, 'box_id' | 'updated_at' | 'is_online' | 'is_backup_battery' | 'is_open' | 'is_unlocked' | 'request_status'>
  & { box: (
    { __typename?: 'box' }
    & Pick<Box, 'name' | 'imei'>
  ) }
);

export type HomeBoxStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type HomeBoxStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { box_status: Array<(
    { __typename?: 'box_status' }
    & BoxStatusFragment
  )> }
);

export type BoxFragment = (
  { __typename?: 'box' }
  & Pick<Box, 'id' | 'name' | 'imei' | 'coords' | 'address' | 'postcode'>
  & { prefectureByPrefecture?: Maybe<(
    { __typename?: 'prefecture' }
    & Pick<Prefecture, 'name'>
  )> }
);

export type BoxesQueryVariables = Exact<{ [key: string]: never; }>;


export type BoxesQuery = (
  { __typename?: 'query_root' }
  & { box: Array<(
    { __typename?: 'box' }
    & BoxFragment
  )> }
);

export type MsgsSubscriptionVariables = Exact<{
  boxId: Scalars['Int'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: Order_By;
}>;


export type MsgsSubscription = (
  { __typename?: 'subscription_root' }
  & { message: Array<(
    { __typename?: 'message' }
    & Pick<Message, 'id' | 'created_at' | 'type' | 'value'>
  )> }
);

export type MsgsCountSubscriptionVariables = Exact<{
  boxId: Scalars['Int'];
}>;


export type MsgsCountSubscription = (
  { __typename?: 'subscription_root' }
  & { message_aggregate: (
    { __typename?: 'message_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'message_aggregate_fields' }
      & Pick<Message_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export const BoxFragmentDoc = gql`
    fragment Box on box {
  id
  name
  imei
  coords
  address
  postcode
  prefectureByPrefecture {
    name
  }
}
    `;
export const AdminBoxFragmentDoc = gql`
    fragment AdminBox on box {
  ...Box
  plate_number
  address
  postcode
  prefecture
  prefectureByPrefecture {
    name
  }
}
    ${BoxFragmentDoc}`;
export const PrefectureFragmentDoc = gql`
    fragment Prefecture on prefecture {
  value
  name
}
    `;
export const BoxStatusFragmentDoc = gql`
    fragment BoxStatus on box_status {
  box_id
  box {
    name
    imei
  }
  updated_at
  is_online
  is_backup_battery
  is_open
  is_unlocked
  request_status
}
    `;
export const AdminBoxesDocument = gql`
    query AdminBoxes($limit: Int!, $offset: Int!) {
  box(order_by: {id: asc}, limit: $limit, offset: $offset) {
    ...AdminBox
  }
  box_aggregate {
    aggregate {
      count
    }
  }
}
    ${AdminBoxFragmentDoc}`;
export const DeleteAdminBoxesDocument = gql`
    mutation DeleteAdminBoxes($boxIds: [Int!]) {
  delete_box(where: {id: {_in: $boxIds}}) {
    returning {
      id
      imei
    }
  }
}
    `;
export const PrefecturesDocument = gql`
    query Prefectures {
  prefecture {
    ...Prefecture
  }
}
    ${PrefectureFragmentDoc}`;
export const GeocodeAddressDocument = gql`
    query GeocodeAddress($address: String!) {
  geocodeAddress(address: $address) {
    lat
    lng
  }
}
    `;
export const UpsertAdminBoxDocument = gql`
    mutation UpsertAdminBox($box: box_insert_input!) {
  insert_box_one(object: $box) {
    id
    imei
  }
}
    `;
export const UpdateAdminBoxDocument = gql`
    mutation UpdateAdminBox($boxId: Int!, $box: box_set_input!) {
  update_box_by_pk(pk_columns: {id: $boxId}, _set: $box) {
    id
    imei
  }
}
    `;
export const UnlockBoxDocument = gql`
    mutation UnlockBox($boxId: Int!, $imei: String!) {
  openBox(boxId: $boxId, imei: $imei) {
    id
    box_id
    created_at
  }
}
    `;
export const HomeBoxStatusDocument = gql`
    subscription HomeBoxStatus {
  box_status {
    ...BoxStatus
  }
}
    ${BoxStatusFragmentDoc}`;
export const BoxesDocument = gql`
    query Boxes {
  box(order_by: {id: asc}) {
    ...Box
  }
}
    ${BoxFragmentDoc}`;
export const MsgsDocument = gql`
    subscription Msgs($boxId: Int!, $limit: Int! = 10, $offset: Int! = 0, $order: order_by! = desc) {
  message(where: {box_id: {_eq: $boxId}}, limit: $limit, offset: $offset, order_by: {created_at: $order}) {
    id
    created_at
    type
    value
  }
}
    `;
export const MsgsCountDocument = gql`
    subscription MsgsCount($boxId: Int!) {
  message_aggregate(where: {box_id: {_eq: $boxId}}) {
    aggregate {
      count
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AdminBoxes(variables: AdminBoxesQueryVariables): Promise<AdminBoxesQuery> {
      return withWrapper(() => client.request<AdminBoxesQuery>(print(AdminBoxesDocument), variables));
    },
    DeleteAdminBoxes(variables?: DeleteAdminBoxesMutationVariables): Promise<DeleteAdminBoxesMutation> {
      return withWrapper(() => client.request<DeleteAdminBoxesMutation>(print(DeleteAdminBoxesDocument), variables));
    },
    Prefectures(variables?: PrefecturesQueryVariables): Promise<PrefecturesQuery> {
      return withWrapper(() => client.request<PrefecturesQuery>(print(PrefecturesDocument), variables));
    },
    GeocodeAddress(variables: GeocodeAddressQueryVariables): Promise<GeocodeAddressQuery> {
      return withWrapper(() => client.request<GeocodeAddressQuery>(print(GeocodeAddressDocument), variables));
    },
    UpsertAdminBox(variables: UpsertAdminBoxMutationVariables): Promise<UpsertAdminBoxMutation> {
      return withWrapper(() => client.request<UpsertAdminBoxMutation>(print(UpsertAdminBoxDocument), variables));
    },
    UpdateAdminBox(variables: UpdateAdminBoxMutationVariables): Promise<UpdateAdminBoxMutation> {
      return withWrapper(() => client.request<UpdateAdminBoxMutation>(print(UpdateAdminBoxDocument), variables));
    },
    UnlockBox(variables: UnlockBoxMutationVariables): Promise<UnlockBoxMutation> {
      return withWrapper(() => client.request<UnlockBoxMutation>(print(UnlockBoxDocument), variables));
    },
    HomeBoxStatus(variables?: HomeBoxStatusSubscriptionVariables): Promise<HomeBoxStatusSubscription> {
      return withWrapper(() => client.request<HomeBoxStatusSubscription>(print(HomeBoxStatusDocument), variables));
    },
    Boxes(variables?: BoxesQueryVariables): Promise<BoxesQuery> {
      return withWrapper(() => client.request<BoxesQuery>(print(BoxesDocument), variables));
    },
    Msgs(variables: MsgsSubscriptionVariables): Promise<MsgsSubscription> {
      return withWrapper(() => client.request<MsgsSubscription>(print(MsgsDocument), variables));
    },
    MsgsCount(variables: MsgsCountSubscriptionVariables): Promise<MsgsCountSubscription> {
      return withWrapper(() => client.request<MsgsCountSubscription>(print(MsgsCountDocument), variables));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;